"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Styles = require("./search.styles");
const Slots = require("./search-slots");
const search_field_box_1 = require("./search-field-box");
const NOOP = function NOOP() { };
exports.Search = function Search(props) {
    const searchResultList = Slots.withSlot(props.children, { slot: Slots.SearchResultListSlot });
    const searchPreviewChildren = Slots.withSlot(props.children, { slot: Slots.SearchResultPreviewSlot });
    const searchField = Slots.withSlot(props.children, { slot: Slots.SearchFieldSlot });
    const searchLegend = Slots.withSlot(props.children, { slot: Slots.SearchLegendSlot });
    const passThrough = Slots.withSlot(props.children, { slot: Slots.SearchPassThroughSlot });
    return (React.createElement(Styles.StyledFormBox, { enabled: props.enabled, inline: props.inline, onClick: props.inline && !props.enabled ? props.onFocus : NOOP },
        React.createElement(Styles.StyledForm, { onSubmit: props.onSubmit, method: "GET" },
            React.createElement(search_field_box_1.SearchFieldBox, { onClick: props.inline ? props.onClick : NOOP },
                searchField,
                passThrough,
                React.createElement("input", { type: "submit", style: { display: 'none' } })),
            searchLegend,
            React.createElement(Styles.StyledResults, null,
                searchResultList,
                searchPreviewChildren))));
};
//# sourceMappingURL=search.js.map